import React from 'react'
import BackendService from '../../../services/BackendService'

/**
 * Representa el componente CustomerCareUser
 *
 * @class CustomerCareUser
 * @extends {React.Component}
 */
class CustomerCareUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      loading: true,
      supportNumber: undefined,
      error: false,
      userIsLogin: false,
      noCp: false,
      errorMessage: 'An error occurred.',
      loginAndLogoutData: {}
    };

    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.isCp = this.isCp.bind(this);

    BackendService.getLoginAndLogoutData(this.props.match.params.cp)
      .then(loginAndLogoutData => {
        this.setState({
          loginAndLogoutData: loginAndLogoutData.result
        })

        return BackendService.getUserToken(this.props.match.params.cp)
          // .then(() => {
          //   return {
          //     result: {
          //       "status" : true,
          //       "user_token" : "bac2602b0431dfbc5a74afa0e362d82b71887923"
          //     }
          //   }
          // })
      })
      .then(status => {
        if (!status.result.status) {
          this.setState({
            userIsLogin: false,
            errorMessage: 'User is not logged in. Please login in.'
          })

          throw new Error('User is not logged in.');
        } else {
          this.setState({
            userIsLogin: true
          })
        }

        return BackendService.getSupportNumber(this.props.match.params.cp, status.result);
      })
      .then(response => {
        if (response.result.ok) {
          this.setState({
            supportNumber: response.result.supportNumber,
            loading: false
          })
        } else {
          if (response.result.error === 'CP-006') {
            this.setState({
              loading: false,
              userIsLogin: false,
              error: true,
              errorMessage: 'User is not logged in. Please login in.'
            })
          } else if (response.result.error === 'Can no find CP') {
            this.setState({
              loading: false,
              error: true,
              errorMessage: 'Can not find content provider.'
            })
          } else {
            this.setState({
              loading: false,
              error: true,
              errorMessage: 'An error occurred.'
            })
          }
        }
      })
      .catch(error => {
        console.log(error);

        this.setState({
          error: true,
          loading: false
        })
      })
  }

  redirectToLogin = () => {
    const { loginAndLogoutData } = this.state;
    let loginUrl;

    if (this.isCp()) {
      loginUrl = loginAndLogoutData.cpLoginUrl;
    } else {
      loginUrl = loginAndLogoutData.loginUrl;
    }

    if(loginUrl) {
      window.location.href=loginUrl
    } else {
      throw new Error('No login Url');
    }
  }

  logout = () => {
    const { loginAndLogoutData } = this.state;

    if (loginAndLogoutData.cpLogoutUrl) {
        window.location.href=loginAndLogoutData.cpLogoutUrl
    } else if (loginAndLogoutData.logoutUrl) {
      this.setState({ loading: true });

      BackendService.logout(loginAndLogoutData.logoutUrl)
        .then(() => {
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
        })
    } else {
      throw new Error('No logout Url');
    }
  }

  isCp = () => {
    const { loginAndLogoutData } = this.state;

    return loginAndLogoutData.cpLoginUrl;
  }

  render() {
    const {
      loading,
      supportNumber,
      error,
      userIsLogin,
      errorMessage
    } = this.state;

    return (
      <div className="container">
        <div className="row margin-bottom-3">
          <h2 className="center-tag">Support Code</h2>
        </div>

        {loading ?
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        :
        <React.Fragment>
          {error ?
          <React.Fragment>
            <div className="alert alert-danger margin-bottom-3" role="alert">
              { errorMessage }
            </div>
          </React.Fragment>
          :
          <React.Fragment>
            <div className="row margin-bottom-7">
              <h4 className="center-tag">{supportNumber}</h4>
            </div>
          </React.Fragment>
          }
          <React.Fragment>
          { !userIsLogin || error ?
            <React.Fragment>
            { this.isCp() ?
              <div className="alert alert-success margin-bottom-3" role="alert">Please click the login button, log in on the page and then return here.</div>
              : ''
            }

            <div className="row margin-bottom-2">
              <button className="btn btn-outline-primary center-tag" type="button" onClick={this.redirectToLogin}>Login</button>
            </div>
            </React.Fragment>
          :
          <div className="row">
            <button className="btn btn-outline-danger center-tag" type="button" onClick={this.logout}>Logout</button>
          </div>
          }
          </React.Fragment>
        </React.Fragment>
        }
      </div>
    );
  }
}

export default CustomerCareUser